import { useRecoilValue } from "recoil";
import useSWR from "swr";
import { ifreaMediaAnalyticsDateRangeState } from "../../store/ifreaMediaAnalyticsDateRangeState";

export const useFetchTotalMediaCall = (restaurantId?: string) => {
  const dateRange = useRecoilValue(ifreaMediaAnalyticsDateRangeState)
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/total-media-call/?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}` : null;
  const { data: totalMediaCall, isLoading } = useSWR<{[key: string]: number}>(fetcherKey)
  return { totalMediaCall, isLoading };
};

